import { isDevMode } from './env-utils';

export const logInDev = (...args) => {
  if (isDevMode()) {
    // eslint-disable-next-line no-console
    console.log('%c∴ LOGGING IN DEV', 'font-family: monospace; font-size: 12px');
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const logErrorInDev = (...args) => {
  if (isDevMode()) {
    // eslint-disable-next-line no-console
    console.log('%c∴ LOGGING ERROR IN DEV', 'font-family: monospace; font-size: 12px');
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
